export const PERCENTAGE = 1
export const FIXED = 2
